<template>
  <div>
    <!-- 功能 -->
    <div class="header-menu">
      <el-input
        class="search"
        placeholder="搜索职级"
        v-model="searchJobName"
        @clear="inputListener"
        clearable
      >
        <el-button
          slot="append"
          type="primary"
          icon="el-icon-search"
          @click="searchJob"
          >搜索</el-button
        >
      </el-input>
      <el-button type="primary" @click="editInfo1" class="addbtn btns"
      size="small" icon="el-icon-plus"
        >添加职级</el-button
      >
    </div>
    <!-- 职级列表 -->
    <el-table
      style="margin-top: 20px;width: 100%;"
      :data="jobList1"
      :stripe="true"
      :highlight-current-row="true"
      height="700"
      row-key="newID"
      :tree-props="{ children: 'teacherRankList' }"
    >
      <!-- <el-table-column label="序号" type="selection"></el-table-column> -->
      <el-table-column prop="salaryPlanName" label="职级名称"></el-table-column>
      
      <el-table-column prop="jobBasepay" label="底薪">
        <template slot-scope="scope"> 
          <span v-if="scope.row.salaryPlanName !== '初级讲师' && scope.row.salaryPlanName !== '中级讲师' && scope.row.salaryPlanName !== '高级讲师'">{{ scope.row.jobBasepay }}</span>  
        </template>
      </el-table-column>
      <!-- <el-table-column prop="createTime" label="开始时间"></el-table-column>
      <el-table-column prop="updateTime" label="结束时间"></el-table-column> -->
      <el-table-column label="操作" fixed="right" width="150" >
        <template slot-scope="scope" v-if="scope.row.salaryPlanName !== '初级讲师' && scope.row.salaryPlanName !== '中级讲师' && scope.row.salaryPlanName !== '高级讲师'"> 
          <el-button type="text" @click="editInfo1(scope.row,'编辑')">编辑</el-button>
          <el-button  @click="editInfo1(scope.row,'查看')" type="text">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 点击查看出现弹层 -->
    <el-dialog
      title="查看职级"
      :visible.sync="showDialogVisible"
      width="40%"
    >
      <el-form class="demo-ruleForm">
        <el-form-item label="有效期:" class="viewalgin">
          <span>{{ changeTimeValue[0] }} 至 {{ changeTimeValue[1]}}</span>
        </el-form-item>
        <el-form-item label="职称:" class="viewalgin">
          <span>{{ jobDetails.jobName }}</span>
        </el-form-item>
        <el-form-item label="底薪:" class="viewalgin">
          <span >{{ jobDetails.jobBasepay }}/月</span>
        </el-form-item>
        <div class="view_box_moudel">
          <div>课时费：</div>
          <div>
            <div v-for="(item, index) in jobDetails.lessonschedules" :key="index" style="margin-bottom:5px;">
              <span>第{{index + 1}}</span>
              <span>学段：{{item.lePeriod ==1 ? "小学" : item.lePeriod ==2 ? "初中" : item.lePeriod == 3 ? "高中" :""}}</span>
              <span>类型：{{item.leType == 1 ? "网课" : item.leType == 2 ? "上门" : ""}}</span>
              <span>课时费：{{item.leMoney}}</span>
            </div>
          </div>
        </div>
        <el-form-item label="义务课时数:" class="viewalgin">
          <span>{{ jobDetails.dutyClassNum }}</span>
        </el-form-item>
        <el-form-item label="义务课时费:" class="viewalgin">
          <span>{{ jobDetails.dutyClassFee }}</span>
        </el-form-item>
        <el-form-item label="是否超课次:" class="viewalgin">
          <span>{{ jobDetails.exceClassTime == 1 ? "是" : "否" }}</span>
        </el-form-item>
        <el-form-item label="基础课时数:" class="viewalgin" v-if="jobDetails.exceClassTime == 1">
         <span> {{jobDetails.basicClassNum}}</span>
        </el-form-item>
        <el-form-item label="超预计课程:" class="viewalgin" v-if="jobDetails.exceClassTime == 1">
         <span> {{jobDetails.excePredictFee}}</span>
        </el-form-item>
        <div class="view_box_moudel" v-if="jobDetails.exceClassTime == 1">
          <div>超课次：</div>
          <div>
            <div v-for="(item, index) in jobDetails.exceTimeList" :key="index" style="margin-bottom:5px;">
              <span>学段：{{item.grade ==1 ? "小学" : item.lePeriod ==2 ? "初中" : item.lePeriod == 3 ? "高中" :""}}</span>
              <span>授课形式：{{item.classType == 1 ? "1v1" : item.classType == 2 ? "1v2" : item.classType == 3 ? "1v3" : ""}}</span>
              <span>超课次奖励：{{item.exceClassAward}}</span>
            </div>
          </div>
        </div>
        <el-form-item label="当天超课次:" class="viewalgin">
         <span> {{ jobDetails.dayExceTime == 1 ? "是" : "否"}}</span>
        </el-form-item>
        <el-form-item label="超课次:" class="viewalgin" v-if="jobDetails.dayExceTime == 1">
          <span style="margin-left:20px;margin-right:20px;">{{jobDetails.dayExceClassNum}} 节</span>
          <span>{{jobDetails.dayExceClassFee}} 元</span>
        </el-form-item>

        <el-form-item label="学生课程累计:" class="viewalgin">
         <span> {{ jobDetails.studentClassTotal == 1 ? "是" : "否"}}</span>
        </el-form-item>

        <div class="view_box_moudel" v-if="jobDetails.exceClassTime == 1">
          <div>课程累计数:</div>
          <div>
            <div v-for="(item, index) in jobDetails.studentTotalList" :key="index" style="margin-bottom:5px;">
              <span style="margin-right:20px;margin-left:20px">超课次奖励：{{item.classTimeNum}}节</span>
              <span>超课次奖励：{{item.classTimeFee}}元</span>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 点击编辑出现弹层 -->
    <el-dialog
      id="edit"
      :title="titleCount"
      :visible.sync="dialogVisibleEdit"
      width="60%"
      :close-on-click-modal = false
    >
      <el-form
      label-width="100px"
      ref="jobDetails"
      :model="jobDetails"
      :rules="rules"
      :validate-on-rule-change='false'
      >
        <!-- <el-form-item label="有效期" prop="startValidDate">
          <el-date-picker
            v-model="changeTimeValue"
            style="width:100%;"
            @change="changeBtnTimeValue"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="职称:" prop="jobName">
          <el-select v-model="jobDetails.jobName" style="width:100%;" placeholder="请选择职级">
              <el-option v-for="ele in lePersList1" :key="ele.value" :label="ele.name" :value="ele.value" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职级:" prop="basicClassNum">
          <el-select v-model="jobDetails.basicClassNum" style="width:100%;" placeholder="请选择职级" @change="changegetJobDetail">
              <el-option v-for="ele in lePersList" :key="ele.id" :label="ele.planName" :value="ele.id" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="底薪:" prop="jobBasepay">
          <el-input :disabled="true" v-model="jobDetails.jobBasepay" placeholder="请输入底薪"> </el-input>
        </el-form-item>

        <!-- <el-form-item label="*课时费"  class="new_changes">
          <el-button
              icon="el-icon-circle-plus-outline"
              @click="addInput('thSubsidy')"
            ></el-button>
            <el-button
              v-if="jobDetails.lessonschedules.length > 1"
              icon="el-icon-remove-outline"
              @click="removeItem('thSubsidy')"
            ></el-button>
        </el-form-item>
        <el-form-item class="new_changes">
          <el-form-item
            v-for="(item, index) in jobDetails.lessonschedules"
            :key="index"
            class="new_changes"
            style="margin-bottom: 10px;"
          >
            <span>第{{ index + 1 }}:</span>
            <el-select
              v-model="item.lePeriod"
              style="width: 80%;"
              placeholder="请选择学段"
            >
              <el-option
                v-for="item in lePeriods"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option
            ></el-select>

            <el-select
              v-model="item.leType"
              style="width: 80%; ;margin-top: 10px;margin-left: 27px;"
              placeholder="请选择类型"
            >
              <el-option
                v-for="item in leTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-input
              v-model="item.leMoney"
              style="margin-top: 10px;width: 80%;margin-left: 27px;"
              placeholder="请输入课时费"
            ></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="义务课时数" prop="dutyClassNum">
          <el-input v-model="jobDetails.dutyClassNum"> </el-input>
        </el-form-item>
        <el-form-item label="义务课时费" prop="dutyClassFee">
          <el-input v-model="jobDetails.dutyClassFee"> </el-input>
        </el-form-item>
        <div  class="new_changes new_chan_bom">
          <el-checkbox v-model="checkedTime" @change="btnChangeExce">是否超课次</el-checkbox>
        </div> -->

        <!-- 超课次内容 -->
        <!-- <el-form-item label="基础课时数" class="new_changes" v-if="jobDetails.exceClassTime == 1">
          <el-input-number v-model="jobDetails.basicClassNum"></el-input-number> <span>节</span>
        </el-form-item>
        <el-form-item label="超预计课程" class="new_changes" v-if="jobDetails.exceClassTime == 1">
          <el-input-number v-model="jobDetails.excePredictFee"></el-input-number> <span>元</span>
        </el-form-item>
        <div  class="new_changes new_chan_bom" v-if="jobDetails.exceClassTime == 1">
          <el-checkbox v-model="checkedTime2" @change="btnChangeExce2">超课次</el-checkbox>
          <el-button
              v-if="jobDetails.exceClassTime2 == 1 "
              icon="el-icon-circle-plus-outline"
              @click="addInput('ecTimes')"
            ></el-button>
            <el-button
              v-if="jobDetails.exceTimeList.length > 1"
              icon="el-icon-remove-outline"
              @click="removeItem('ecTimes')"
            ></el-button>
        </div> -->
        <!-- <el-form-item v-if="jobDetails.exceClassTime == 1" label="超课次" class="new_changes">
           <el-button
              icon="el-icon-circle-plus-outline"
              @click="addInput('ecTimes')"
            ></el-button>
            <el-button
              v-if="jobDetails.lessonschedules.length > 1"
              icon="el-icon-remove-outline"
              @click="removeItem('ecTimes')"
            ></el-button>
        </el-form-item> -->
        <!-- <div v-if="jobDetails.exceClassTime == 1 && jobDetails.exceClassTime2 == 1">
          <div v-for="(item,index) in jobDetails.exceTimeList" :key="index" class="period_select">
            <span>学段：</span>
            <el-select v-model="item.grade" style="width:150px;margin-right:20px;" placeholder="请选择学段">
              <el-option v-for="ele in lePersList" :key="ele.value" :label="ele.name" :value="ele.value" ></el-option>
            </el-select>
              <span>授课形式：</span>
              <el-select v-model="item.classType" style="width:150px;margin-right:20px;" placeholder="请选择学段">
                <el-option v-for="ele in classTyList" :key="ele.value" :label="ele.name" :value="ele.value" ></el-option>
              </el-select>
              <span>超课次奖励：</span>
              <el-input-number style="width:150px;margin-right:5px;" v-model="item.exceClassAward"></el-input-number><span>元</span>
          </div>
        </div>
        <div  class="new_changes new_chan_bom">
          <el-checkbox v-model="checkeDayExceTime" @change="btnDayExceTime">当天超课次</el-checkbox>
        </div>
        <el-form-item class="new_changes" label="超课次" v-if="jobDetails.dayExceTime == '1'">
          <el-input-number v-model="jobDetails.dayExceClassNum"  style="width:150px;"></el-input-number> <span style="margin-right:20px">节</span>
          <el-input-number v-model="jobDetails.dayExceClassFee" style="width:150px;"></el-input-number> <span>元</span>
        </el-form-item>
        <div class="new_changes new_chan_bom">
          <el-checkbox v-model="checkedTotal" @change="styBtnChangeTotal">学生课程累计</el-checkbox>
          <el-button
              icon="el-icon-circle-plus-outline"
              @click="addInput('Hypercourse')"
              v-if="jobDetails.studentClassTotal == '1'"
            ></el-button>
            <el-button
              icon="el-icon-remove-outline"
              @click="removeItem('Hypercourse')"
              v-if="jobDetails.studentClassTotal == '1'&&jobDetails.studentTotalList.length > 1"
            ></el-button>
        </div>

        <el-form-item class="new_changes" label="课程累计数" v-if="jobDetails.studentClassTotal == '1'">
          <div v-for="(item,index) in jobDetails.studentTotalList" :key="index" class="new_chan_bom">
            <el-input-number v-model="item.classTimeNum" style="width:150px;"></el-input-number> <span style="margin-right:20px">节</span>
          <el-input-number v-model="item.classTimeFee" style="width:150px;"></el-input-number> <span>元</span>
          </div>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleEdit = false">取 消</el-button>
        <el-button type="primary" @click="saveEdit1('jobDetails')">
          <!-- <span>{{ titleCount == "修改职级" ? '编辑' : '保存'}}</span> -->
          保 存
        </el-button>
      </span>
    </el-dialog>

    <!-- 上一页，当前页，下一页 -->
    <div class="footer-button">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="jobParameters.currentpage"
        :page-size="jobParameters.pagesize"
        layout="prev, pager, next,sizes,jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { fromData } from '@/utils/util'
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  name: "TeacherList",
  data() {
    return {
      jobList: [],
      jobList1: [],
      searchJobName: "",
      classTyList:
      [
        {
          value: 1,
          name: "1v1"
        },
        {
          value: 2,
          name: "1v2"
        },
        {
          value: 3,
          name: "1v3"
        }
      ],
      lePersList: [
      
      ],

      lePersList1: [
        {
          value: 1,
          name: "初级讲师"
        },
        {
          value: 2,
          name: "中级讲师"
        },
        {
          value: 3,
          name: "高级讲师"
        }
      ],

      lePeriods: [
        {
          value: 1,
          name: "小学"
        },
        {
          value: 2,
          name: "初中"
        },
        {
          value: 3,
          name: "高中"
        },
        {
          value: 4,
          name: "规划课"
        }
      ],
      leTypes: [
        {
          id: 1,
          name: "网课"
        },
        {
          id: 2,
          name: "上门"
        }
      ],
      jobParameters: {
        pagesize: 10, //每页多少条
        currentpage: 1 //当前页码
      },

      total: 0,
      dialogVisible: false,
      showDialogVisible: false,
      dialogVisibleEdit: false,
      // stages: [{
      //   lePeriod: '',
      //   leType: '',
      //   leMoney: '',
      //   }],
      changeTimeValue:"", // 时间选择
      exceClassIShow:false,
      ruleForm: {
        jobName: "",
        jobBasepay: ""
      },
      titleCount:"",
      checkedTotal:false,
      checkeDayExceTime:false,
      checkedTime:false,
      checkedTime2:false,
      jobDetails: {
        startValidDate:'',
        endValidDate:"",
        jobName: "",
        jobBasepay: "",
        dutyClassFee:"",  // 义务课时费
        dutyClassNum:"",  // 义务课时数
        exceClassTime:"0", // 是否超课次
        exceClassTime2:"0", // 是否超课次  下面的超课次
        basicClassNum:"",  // 基础课时数
        excePredictFee:"", // 超预计课程
        dayExceTime:"0",  // 当天是否超课次
        dayExceClassNum:"",  // 当天超课次数量
        dayExceClassFee:"",  // 当天超课次金额
        studentClassTotal:"0", // 学生课程累计
        lessonschedules:[      // 课时费
          {
            lePeriod:"",
            leType:"",
            leMoney:"",
          }
        ],
        exceTimeList:[
          {
            grade:"",
            classType:"",
            exceClassAward:"",
          }
        ], // 超课次表
        studentTotalList:[      // 学生课程累计
           {
            classTimeFee:"",
            classTimeNum:""
           }
        ],
      },
      rules: {
        jobName: [
          { required: true, message: "请输入职级名称", trigger: "blur" }
        ],
        basicClassNum: [
          { required: true, message: "职级不能为空", trigger: "blur" }
        ],
        startValidDate: [
          { required: true, message: "有效期不能为空", trigger: "blur" }
        ],
        dutyClassNum: [
          { required: true, message: "义务课时数不能为空", trigger: "blur" }
        ],
        dutyClassFee: [
          { required: true, message: "义务课时费不能为空", trigger: "blur" }
        ],
      },


      rowid: "",

    };
  },
  created() {
    this.getAllJob();
  },

  mounted() {
    axios.get(`${apiBaseUrl}/salaryPlan/salaryPlanNameList`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
       if(res.data.code == 200) {
        this.lePersList = res.data.data;
       }else{
        this.$message.error(res.data.message);
       }
    })
    .catch(err => {
      console.log(err);
      this.$message.error(err);
    });

  },

  methods: {

    changegetJobDetail(row) {
      // 去id相同的
      let itmes = this.lePersList.filter((itme)=>{
         return itme.id == row
      })

      this.jobDetails.jobBasepay = itmes.length > 0 ? itmes[0].jobBasepay : ""

      console.log(itmes) 
    },


    btnChangeExce(val){
      this.jobDetails.exceClassTime = val  ? "1" : "0"
    },
    btnChangeExce2(val){
      this.jobDetails.exceClassTime2 = val  ? "1" : "0"
    },
    btnDayExceTime(val){
      this.jobDetails.dayExceTime = val  ? "1" : "0"
    },
    styBtnChangeTotal(val){
      this.jobDetails.studentClassTotal = val  ? "1" : "0"
    },
    //减少输入框
    removeItem(val) {
      if (val == "thSubsidy") {
        this.jobDetails.lessonschedules.pop();
      }else if(val == "ecTimes"){
        this.jobDetails.exceTimeList.pop();
      }else{
        this.jobDetails.studentTotalList.pop()
      }
    },
    //添加输入框
    addInput(val) {
      if (val == "thSubsidy") {
        this.jobDetails.lessonschedules.push({
          lePeriod: "", //学段
          leType: "", //类型
          leMoney: "" //课时费
        });
      }else if(val == "ecTimes"){
        this.jobDetails.exceTimeList.push({
            grade:"",
            classType:"",
            exceClassAward:"",
        })
      }else{
        this.jobDetails.studentTotalList.push({
          classTimeNum:"",
          classTimeFee:""
        })
      }

    },
    changeBtnTimeValue(val){
      console.log(val);
      this.jobDetails.startValidDate = fromData(val[0])
      this.jobDetails.endValidDate = fromData(val[1])
    },
    //获取职级列表
    getAllJob() {
      axios.post(`${apiBaseUrl}/teacherRank/findList`, {},{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
         if(res.data.code == 200) {
          
            let itmes = res.data.data.map((itme)=>{

                itme.newID = itme.rankType + 'guci'

                if(itme.teacherRankList.length > 0) {
                    itme.teacherRankList.forEach((itemss)=>{
                        itemss.newID = itemss.rankType + 'm' + itemss.id + 's' +itme.rankType + 'mima'
                        itemss.rankTypeName = itemss.salaryPlanName
                        itemss.salaryId = itemss.salaryId
                        itemss.createTime = itemss.createTime
                        itemss.updateTime = itemss.updateTime
                    })
                }

                return itme
                
            })

            this.jobList1 = itmes
            console.log(this.jobList1);

         }else {
            this.$message.error(res.data.message);
            this.jobList1 =  []
          }
      }).catch(err => {
          this.jobList1 =  []
      });

        // .post(`${apiBaseUrl}/job/joblist`, {
        //   page: this.jobParameters.currentpage,
        //   limit: this.jobParameters.pagesize,
        //   jobName: this.searchJobName
        // },{
        //   headers:{
        //     'authorization': sessionStorage.getItem('tokenInfo')
        //   }
        // })
        // .then(res => {
        //   // console.log(res);
        //   this.jobList = res.data.data.list;
        //   this.total = res.data.data.count;
        // })
        // .catch(err => {
        //   console.log(err);
        // });
    },
    //点击搜索职级
    searchJob() {
      this.getAllJob();
    },
    //添加职级弹窗
    addJobName() {
      this.dialogVisibleEdit = true;
    },
    //添加职级保存
    saveInfo(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          axios
            .post(`${apiBaseUrl}/job/jobadd`, this.ruleForm,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
            .then(res => {
              this.jobList.push(res.data);
              this.dialogVisible = false;
              this.getAllJob();
              this.$message.success(res.message);
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          return false;
        }
      });
    },
    getJobDetail(id) {
      const data = {
        jobId: id
      };
      axios
        .post(`${apiBaseUrl}/job/jobdetails`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          // console.log(res, "8888989898978");
          this.jobDetails = res.data.data.details;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //点击查看弹层
    handleClick(row) {
      this.getJobDetail(row.jobId);
      this.showDialogVisible = true;
    },

  
    editInfo1(row,val) {
      if(val === "查看"){
        this.editInfo(row,val) 
      }
      else if(val === "编辑"){

        this.titleCount = '编辑';
        this.dialogVisibleEdit = true;
        this.rowid = row.id;

        this.jobDetails.jobName = row.rankType;
        this.jobDetails.basicClassNum = row.salaryId;
        this.jobDetails.jobBasepay = row.jobBasepay;

        console.log(row)
      }
      else{
        this.titleCount = '添加';
        this.dialogVisibleEdit = true;
        this.jobDetails.jobName = '';
        this.jobDetails.basicClassNum = '';
        this.jobDetails.jobBasepay = '';

      }
    },

    //点击编辑弹层回显数据  添加也走此入口
    editInfo(row,val) {
      this.changeTimeValue = ""
      this.checkedTotal = false
      this.checkeDayExceTime = false
      this.checkedTime = false
      this.checkedTime2 = false
      this.jobDetails = {
        startValidDate:'',
        endValidDate:"",
        jobName: "",
        jobBasepay: "",
        exceClassTime:"0", // 是否超课次
        basicClassNum:"",
        excePredictFee:"",
        dayExceTime:"0",  // 当天是否超课次
        dayExceClassNum:"",  // 当天超课次数量
        dayExceClassFee:"",  // 当天超课次金额
        studentClassTotal:"0", // 学生课程累计
        lessonschedules:[{lePeriod:"",leType:"",leMoney:""}],
        exceTimeList:[{grade:"",classType:"",exceClassAward:""}], // 超课次表
        studentTotalList:[{classTimeFee:"",classTimeNum:""}],
      }
      if (row) {
        this.titleCount = "修改职级"
        const data = { jobId: row.jobId };
        axios
          .post(`${apiBaseUrl}/job/jobdetails2`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then(res => {
             if(res.data.code == 200) {
                this.jobDetails = res.data.data.details;
                if (!this.jobDetails.startValidDate || !this.jobDetails.endValidDate) {
                  // this.changeTimeValue = [this.jobDetails.startValidDate,this.jobDetails.endValidDate]
                }else{
                  this.changeTimeValue = [this.jobDetails.startValidDate,this.jobDetails.endValidDate]
                }

                if (this.jobDetails.exceClassTime == "1") {
                  this.checkedTime = true
                }
                if (this.jobDetails.exceClassTime == "1" && this.jobDetails.exceClassTime2 == '1') {
                  this.checkedTime2 = true
                }
                if (this.jobDetails.dayExceTime == "1") {
                  this.checkeDayExceTime = true
                }
                if (this.jobDetails.studentClassTotal == "1") {
                  this.checkedTotal = true
                }
                // 旧数据处理  添加数据

                if (!this.jobDetails.lessonschedules) { // 课时费
                  this.jobDetails.lessonschedules =
                  [{lePeriod:"",leType:"",leMoney:""}]
                }
                if (!this.jobDetails.exceTimeList) { // 是否超课次
                  this.jobDetails.exceTimeList = [{ grade:"",classType:"",exceClassAward:""}]
                }
                if (!this.jobDetails.studentTotalList) { //  学生课程累计
                  this.jobDetails.studentTotalList = [{ classTimeFee:"",classTimeNum:""}]
                }
             }
            if (val == "查看") {
              this.showDialogVisible = true;
            }else{
              this.dialogVisibleEdit = true;
            }
          })
          .catch(err => {
            console.log(err);
          });

      }else{
        this.titleCount = "添加职级"
        this.dialogVisibleEdit = true;
      }
    },

    saveEdit1() {
      let url = ''
      let data = {}
      if(this.titleCount == "添加"){
        url = 'teacherRank/add'
        data  = {
          rankType: this.jobDetails.jobName,          //职级类型 1初级 2中级 3高级
          salaryId: this.jobDetails.basicClassNum            //薪资方案id 1.1接口返回
        }
      }
      if(this.titleCount == "编辑"){
        url = 'teacherRank/update'
        data  = {
          id: this.rowid,
          rankType: this.jobDetails.jobName,          //职级类型 1初级 2中级 3高级
          salaryId: this.jobDetails.basicClassNum            //薪资方案id 1.1接口返回
        }
      }

      
      axios.post(`${apiBaseUrl}/${url}`, data,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') }  }).then(res => {
         this.dialogVisibleEdit = false;
         this.getAllJob();
         this.$message.success(res.data.message);

       }).catch(err => {
         console.log(err);
         this.$message.error(err);
       });
    },

    //点击 编辑 保存数据
    saveEdit(jobDetails) {
      //  校验课时费
        this.$refs[jobDetails].validate(valid => {
          if (valid) { // 校验前三项
            // 校验课时费
            if (!this.jobDetails.lessonschedules[0].lePeriod || !this.jobDetails.lessonschedules[0].leType || !this.jobDetails.lessonschedules[0].leMoney) {
              this.$message.error('请选填课时费')
              return
            }
            // 是否超课次
            if (this.jobDetails.exceClassTime == "0") {
              this.jobDetails.basicClassNum = ""
              this.jobDetails.excePredictFee = ""
              this.jobDetails.exceTimeList = [{grade:"",classType:"",exceClassAward:""}]
            }else{
              // 上面两项
              if (!this.jobDetails.basicClassNum || !this.jobDetails.excePredictFee) {
                this.$message.error('请输入是否超课次 基础课时数或超预计课程')
                return
              }
              if (this.jobDetails.exceClassTime2 == 1) {
                if (!this.jobDetails.exceTimeList[0].grade || !this.jobDetails.exceTimeList[0].classType || !this.jobDetails.exceTimeList[0].exceClassAward) {
                  this.$message.error('请输入超课次内容')
                  return
                }
              }

            }
            // 当天是否超课次
            if (this.jobDetails.dayExceTime == "0") {
                this.jobDetails.dayExceClassNum = ""
                this.jobDetails.dayExceClassFee = ""
            }else{
              if (!this.jobDetails.dayExceClassNum || !this.jobDetails.dayExceClassFee) {
                this.$message.error("请填写当天超课次信息")
                return
              }
            }
            //  学生课程累计
            if (this.jobDetails.studentClassTotal == "0") {
                 this.jobDetails.studentTotalList = [ { classTimeNum:"", classTimeFee:"" }]
            }else{
                if (!this.jobDetails.studentTotalList[0].classTimeNum || !this.jobDetails.studentTotalList[0].classTimeFee) {
                  this.$message.error("请填写学生课程累计")
                  return
                }
            }
            if (this.titleCount == "添加职级") {// 保存
                  axios .post(`${apiBaseUrl}/job/jobadd`, this.jobDetails,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
                    this.jobList.push(res.data);
                    this.dialogVisibleEdit = false;
                    this.getAllJob();
                    this.$message.success('添加成功');
                  }).catch(err => {
                    console.log(err);
                  });
            }else{ // 编辑
                console.log("编辑职级");
                axios.put(`${apiBaseUrl}/job/jobset`, this.jobDetails,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
                    if (res.data.code == 200) {
                      this.$message({  message: res.data.message,   type: "success" });
                      this.dialogVisibleEdit = false;
                      this.getAllJob();
                    } else {
                      this.$message({ message: res.data.message, type: "error"  });
                    }
                  }).catch(err => {
                    console.log(err);
                  });
            }
          } else {
            return false;
          }
        });

    },
    //点击删除
    deleteInfo(row){
        axios.delete(`${apiBaseUrl}/delete/${row.jobId}`,{headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          this.$message({ message: "删除成功", type: "success" });
          this.getAllJob();
        }).catch(error => {
          this.$message.error(error);
        });
    },
    //分页
    handleSizeChange(pageSize) {
      this.jobParameters.pagesize = pageSize;
      if (this.jobParameters.page === 1) {
        this.getAllJob(this.jobParameters);
      }
    },
    //进入某一页
    handleCurrentChange(newPage) {
      this.jobParameters.currentpage = newPage;
      this.getAllJob();
    },
    inputListener() {
      this.getAllJob();
    }
  }
};
</script>

<style scoped>
.addbtn {
  margin-left: 15px;
}

.el-input-group {
  width: 40%;
}

.header-menu {
  margin-bottom: 5px;
  padding: 0;
  text-align: left;
  margin-bottom: 5px;
}
.jobname {
  margin-right: 370px;
}
.footer-button {
  margin-top: 10px;
}
.money {
  margin-right: 366px;
}
.new_changes{
  width: 100%;
  text-align: left;
}
.changes_flex{
  width: 30%;
}
/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }
  .search {
    width: 200px;
  }
  .btn {
    margin-left: -71px;
  }
  .add {
    margin-left: -41px;
    margin-right: -70px;
  }
  /* .jobnames {
    margin-right: 370px;
  } */
  /* 兼容移动端 */
  #oo >>> .el-dialog {
    width: 70% !important;
  }
  /* .pop{
    margin-left: -15% !important;
  } */
  #ff >>> .el-dialog {
    width: 70% !important;
  }
  #edit >>> .el-dialog {
    width: 70% !important;
  }
}
.period_select{
  margin-bottom:20px;
  white-space: nowrap;
  overflow-x: auto;
}
::-webkit-scrollbar {
    display: none;
  }
  .new_chan_bom{
    margin-bottom: 20px;
  }
  .viewalgin{
    text-align: left;
  }
  .view_box_moudel{
    display: flex;
    margin-bottom: 20px;
  }
  .btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/TeacherSetting.vue